import { render, staticRenderFns } from "./t-pagination.vue?vue&type=template&id=dd83ee74&"
import script from "./t-pagination.vue?vue&type=script&lang=js&"
export * from "./t-pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports